import * as React from 'react'

import { Box, Hint } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'
import { useLocalStorage } from 'usehooks-ts'

import { observer } from 'mobx-react'

import type LogicOperatorForm from 'modules/core/components/MultiFilters/Forms/LogicOperatorForm'
import type MultiFilterForm from 'modules/core/components/MultiFilters/Forms/MultiFilterForm'
import i18n from 'modules/core/lib/i18n'

import { MultiFiltersSelector } from 'modules/shift_management/components/ShiftManagement/Content/TableHeader/CommandsFilterBar/MultifiltersSelector'
import { OldMultiFiltersSelector } from 'modules/shift_management/components/ShiftManagement/Content/TableHeader/CommandsFilterBar/OldMultiFiltersSelector'
import { ViewOptionsSectionButton } from 'modules/shift_management/components/ShiftManagement/Content/TableHeader/ShiftActionsBar/ViewOptionsSectionButton'
import { Separator } from 'modules/shift_management/components/ShiftManagement/Separator'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'

import ViewSelectorOld from './ViewSelector/indexOld'

interface Props {
  filters: MultiFilterForm[]
  logicOperator: LogicOperatorForm
  disabled?: boolean
  onAddFilter: () => void
  onRemoveFilter: (index: number) => void
  onApplyFilters: () => void
  onCancel: () => void
  onResetFilters: () => void
  canManageShifts: boolean
  hasNoneShiftManagementPlanning: boolean
}

const CommandsFilterBar = ({
  filters,
  logicOperator,
  disabled,
  onAddFilter,
  onRemoveFilter,
  onApplyFilters,
  onCancel,
  onResetFilters,
  canManageShifts,
  hasNoneShiftManagementPlanning,
}: Props) => {
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const hasMonthlyView = hasFeatureFlag('shift_management_monthly_view')
  const newEntryFlowEnabled = hasFeatureFlag('dev_shift_management_autoscheduler_entry_flow')
  const newMultiFiltersEnabled = hasFeatureFlag('dev_shift_management_new_multi_filters')
  const [hasSeenNewEntryFlowHints] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS.shiftManagementHasSeenNewEntryFlowHints,
    false
  )

  return (
    <Box
      flexDirection="row"
      gap="s32"
      alignItems="center"
      minWidth="none"
      flexNoShrink
      flexGrow
      style={{ flexBasis: '0' }}
    >
      <Box flexDirection="row" gap="s8" alignItems="center">
        {newMultiFiltersEnabled ? (
          <MultiFiltersSelector />
        ) : (
          <OldMultiFiltersSelector
            filters={filters}
            logicOperator={logicOperator}
            onAddFilter={onAddFilter}
            onRemoveFilter={onRemoveFilter}
            onApplyFilters={onApplyFilters}
            onCancel={onCancel}
            onResetFilters={onResetFilters}
          />
        )}
        {newEntryFlowEnabled && <Separator />}
        <Box minWidth="s96">
          {newEntryFlowEnabled ? (
            !hasSeenNewEntryFlowHints ? (
              <Hint.Popover
                step={1}
                title={i18n.t('shift_management.hints.filters.title')}
                description={i18n.t('shift_management.hints.filters.description')}
                actionLabel={i18n.t('common.next')}
                position="bottom right"
              >
                <ViewOptionsSectionButton
                  disabled={hasNoneShiftManagementPlanning}
                  canManageShifts={canManageShifts}
                />
              </Hint.Popover>
            ) : (
              <ViewOptionsSectionButton
                disabled={hasNoneShiftManagementPlanning}
                canManageShifts={canManageShifts}
              />
            )
          ) : (
            <ViewSelectorOld disabled={!hasMonthlyView || disabled} />
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default observer(CommandsFilterBar)
